"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireWildcard(require("react"));
var _reactRouterDom = require("react-router-dom");
var _reactSlick = _interopRequireDefault(require("react-slick"));
var _QuickHelp = _interopRequireDefault(require("@concur/nui-widgets/lib/Popover/QuickHelp"));
var _nuiIntlRuntime = require("@concur/nui-intl-runtime");
var _IconButton = _interopRequireDefault(require("@concur/nui-widgets/lib/IconButton/IconButton"));
var _nuiLogger = _interopRequireDefault(require("@concur/nui-logger"));
var _MiniListing = _interopRequireDefault(require("../shared/MiniListing"));
var _utils = require("../utils");
var _Arrow = _interopRequireDefault(require("./Arrow"));
var _withRouter = require("../HOCs/withRouter");
!!(typeof window !== 'undefined' && window.document && window.document.createElement) ? require("slick-carousel/slick/slick.css") : void 0;
!!(typeof window !== 'undefined' && window.document && window.document.createElement) ? require("./style/slick-carousel.css") : void 0;
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var AppCategory = /*#__PURE__*/function (_Component) {
  function AppCategory(props) {
    var _this;
    _classCallCheck(this, AppCategory);
    _this = _callSuper(this, AppCategory, [props]);
    _defineProperty(_this, "renderListings", function () {
      var lazyLoadListings = _this.props.lazyLoadListings;
      var sliderFeaturesVisibility = _this.getSliderVisibility();
      var variableMargins = sliderFeaturesVisibility ? '' : 'no-side-margins';
      var sliderSettings = {
        dots: true,
        infinite: false,
        speed: 500,
        lazyLoad: lazyLoadListings,
        nextArrow: /*#__PURE__*/_react.default.createElement(_IconButton.default, {
          iconName: "arrow-1-e",
          type: "link",
          ariaLabel: _this.formatter.formattedMessage({
            id: 'btnNextPageMouseover'
          })
        }),
        prevArrow: /*#__PURE__*/_react.default.createElement(_IconButton.default, {
          iconName: "arrow-1-w",
          type: "link",
          ariaLabel: _this.formatter.formattedMessage({
            id: 'btnPreviousPageMouseover'
          })
        }),
        responsive: [{
          breakpoint: 390,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1
          }
        }, {
          breakpoint: 580,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 2
          }
        }, {
          breakpoint: 768,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 3
          }
        }, {
          breakpoint: 980,
          settings: {
            slidesToShow: 4,
            slidesToScroll: 4
          }
        }, {
          breakpoint: 1200,
          settings: {
            slidesToShow: 5,
            slidesToScroll: 5
          }
        }, {
          breakpoint: 10000,
          settings: {
            slidesToShow: 6,
            slidesToScroll: 6
          }
        }],
        className: "slider-row ".concat(variableMargins),
        dotsClass: "".concat(sliderFeaturesVisibility ? 'ac-listings-slider-dots' : 'hidden'),
        customPaging: function customPaging(i) {
          return /*#__PURE__*/_react.default.createElement(_IconButton.default, {
            style: {
              minWidth: '20px',
              minHeight: '20px'
            },
            innerProps: {
              className: 'hide-outline'
            },
            type: "button",
            compact: "true",
            ariaLabel: _this.formatter.formattedMessage({
              id: 'pageNumber',
              values: {
                index: i + 1
              }
            })
          });
        },
        draggable: true,
        afterChange: function afterChange(current) {
          try {
            var firstSlide = _this.sliderRef.current.innerSlider.list.children[0].children[current];
            var listingLink = _this.getListingLink(firstSlide);
            listingLink.focus();
          } catch (err) {
            _nuiLogger.default.error({
              description: "Error setting focus on carousel: ".concat(err.message),
              category: 'react-slick'
            });
          }
        }
      };
      return /*#__PURE__*/_react.default.createElement("div", {
        className: "listings-row-responsive"
      }, /*#__PURE__*/_react.default.createElement(_reactSlick.default, _extends({}, sliderSettings, {
        ref: _this.sliderRef
      }), _this.props.listings.map(function (listing, i) {
        var listingLink = "".concat((0, _utils.getAppCenterPathName)(_this.props.location.pathname), "/listings/").concat(listing.ID);
        return /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement(_reactRouterDom.Link, {
          key: i,
          to: listingLink,
          className: "mini-listing-link",
          "data-analytics": "ec=".concat(listing.localized.name, "\n                |ea=ViewDetails\n                |dp=Home\n                |dt=AppCenterHome\n                |cd2=nui")
        }, /*#__PURE__*/_react.default.createElement("span", {
          style: {
            display: 'inline-block'
          }
        }, /*#__PURE__*/_react.default.createElement(_MiniListing.default, {
          listing: listing,
          isLoggedIn: _this.props.isLoggedIn,
          betas: _this.props.betas,
          location: _this.props.location
        }))));
      })));
    });
    _this.state = {
      width: 0,
      height: 0
    }; // eslint-disable-line react/no-unused-state
    _this.updateWindowDimensions = _this.updateWindowDimensions.bind(_this);
    _this.formatter = _this.props.formatter;
    _this.sliderRef = /*#__PURE__*/_react.default.createRef(null);
    return _this;
  }
  _inherits(AppCategory, _Component);
  return _createClass(AppCategory, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.updateWindowDimensions();
      window.addEventListener('resize', this.updateWindowDimensions);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      window.removeEventListener('resize', this.updateWindowDimensions);
    }
  }, {
    key: "updateWindowDimensions",
    value: function updateWindowDimensions() {
      this.setState({
        width: window.innerWidth,
        height: window.innerHeight
      }); // eslint-disable-line react/no-unused-state
    }
  }, {
    key: "getSliderVisibility",
    value: function getSliderVisibility() {
      var sliderFeaturesVisibility = false;
      if (this.props.listings.length > 6 && this.state.width > 1200) {
        sliderFeaturesVisibility = true;
      } else if (this.props.listings.length > 5 && this.state.width > 980 && this.state.width <= 1200) {
        sliderFeaturesVisibility = true;
      } else if (this.props.listings.length > 4 && this.state.width > 768 && this.state.width <= 980) {
        sliderFeaturesVisibility = true;
      } else if (this.props.listings.length > 2 && this.state.width <= 768) {
        sliderFeaturesVisibility = true;
      }
      return sliderFeaturesVisibility;
    }
  }, {
    key: "renderArrow",
    value: function renderArrow(prevNext, isVisible) {
      return /*#__PURE__*/_react.default.createElement(_Arrow.default, {
        direction: prevNext,
        areSlideFeaturesVisible: isVisible ? '' : 'hidden'
      });
    }
  }, {
    key: "getListingLink",
    value: function getListingLink(node) {
      if (node.classList.contains('mini-listing-link')) {
        return node;
      }
      // Go to the next child
      return this.getListingLink(node.children[0]);
    }
  }, {
    key: "render",
    value: function render() {
      var formatter = this.props.formatter;
      var dataTestId = this.props['data-testid'];
      if (this.props.listings.length === 0) {
        return null;
      }
      return /*#__PURE__*/_react.default.createElement("div", {
        "data-testid": dataTestId
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "row listings-row-responsive"
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "col-sm-12"
      }, /*#__PURE__*/_react.default.createElement("h2", {
        className: "collection-title"
      }, this.props.categoryTitle), this.props.categoryQuickHelpMessage ? /*#__PURE__*/_react.default.createElement(_QuickHelp.default, {
        message: this.props.categoryQuickHelpMessage,
        textShowQuickHelp: formatter.formattedMessage({
          id: 'QuickHelpLabel',
          values: {
            collection: this.props.categoryTitle
          }
        }),
        title: this.props.categoryTitle,
        textClose: formatter.formattedMessage({
          id: 'Close'
        }),
        className: "collection-quick-help",
        "data-testid": dataTestId ? "".concat(dataTestId, "-QuickHelp") : ''
      }) : null, /*#__PURE__*/_react.default.createElement("p", {
        className: "collection-description"
      }, this.props.categorySubtitle))), this.renderListings());
    }
  }]);
}(_react.Component);
AppCategory.propTypes = {
  categoryTitle: _propTypes.default.string.isRequired,
  categorySubtitle: _propTypes.default.any.isRequired,
  categoryQuickHelpMessage: _propTypes.default.any,
  listings: _propTypes.default.array.isRequired,
  isLoggedIn: _propTypes.default.bool.isRequired,
  location: _propTypes.default.object,
  betas: _propTypes.default.object,
  formatter: _propTypes.default.object,
  lazyLoadListings: _propTypes.default.string
};
var _default = exports.default = (0, _withRouter.withRouter)((0, _nuiIntlRuntime.withFormatter)(AppCategory));